module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.showHeader) ? _c('app-header') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "route_view"
  }, [_c('keep-alive', [_c('router-view')], 1)], 1), _vm._v(" "), (_vm.showFooter) ? _c('app-footer') : _vm._e(), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline"
    }
  }, [_c('img', {
    staticStyle: {
      "border-style": "none"
    },
    attrs: {
      "height": "1",
      "width": "1",
      "alt": "",
      "src": "//googleads.g.doubleclick.net/pagead/viewthroughconversion/852175291/?guid=ON&script=0"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09aad170"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 818
// module chunks = 1